export const dateFormatTypes = Object.freeze({
  shortWeekDateName: 'shortWeekDateName',
  monthDay: 'monthDay',
  dayMonthYear: 'dayMonthYear',
  dayMonthYearTime: 'dayMonthYearTime',
  shortDate: 'shortDate',
});
